/**
 * `cn` — class-name concat helper.
 *
 * Combines clsx (for conditional logic) + tailwind-merge (so later
 * utilities override earlier ones — e.g. `cn('p-4', 'p-6')` → `p-6`).
 */

import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
